import React, { Component } from 'react';
import { connect } from "react-redux";
import ReportsHeader from "../ReportsHeader";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar,Pie,Line } from 'react-chartjs-2';
import { toast } from 'react-toastify';
import API from "../../../lib/api"

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class GeneralReport extends Component {

    constructor(props) {
        super(props);
		
		this.state = {
            filterStart: "",
			filterEnd: "",
			showReport: false,
			loadingReport: false,
			optionsFilter: {},
			dataFilter: {},
			dataFilter2: {},
			filterLabels: {},
			filterNegative: {},
			filterPositive: {},
			filterChat: {},
			
        };
		
ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
		
		this.onChangeFilterStart = this.onChangeFilterStart.bind(this);
		this.onChangeFilterEnd = this.onChangeFilterEnd.bind(this);
		this.filterReport=this.filterReport.bind(this);
    }
	
	onChangeFilterStart(e) {
        this.setState({
                filterStart : e.target.value
        });
    }
	
	onChangeFilterEnd(e) {
        this.setState({
                filterEnd : e.target.value
        });
    }
	
	filterReport(e){
		this.setState({
                showReport : false,
                loadingReport : true
		});
		
		
		
		

		

		if(this.state.filterStart != "" && this.state.filterEnd != ""){
			
			
			
		var formData = new FormData();
        formData.append("start", this.state.filterStart);
        formData.append("end", this.state.filterEnd);

        API.post("reports/hourlyReports",formData).then((response) => {
            if (response.status === 200) {
				this.setState({
					loadingReport : false
				});
				
				
				
				
                if(typeof response.data.success!=="undefined"){
				

		var labels = response.data.labels;
		var chat = response.data.datasets.chat;
		
			
				
	
			this.setState({
				filterLabels: labels,
				filterChat: chat,
                showReport : true,
				optionsFilter: {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: '',
    },
  },
},
				dataFilter: {
  labels,
  datasets: [
    {
	  fill: true,
      label: "Total Chat",
      data: chat,
	  borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)'
    }
  ]
},
dataFilter2: {
  labels: labels,
  datasets: [
    {
      label: 'Total Chat',
      data: chat,
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgba(228, 131, 45, 0.2)',
        'rgba(129, 215, 66, 0.2)',
        'rgba(255, 84, 208, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
        'rgba(228, 131, 45, 1)',
		'rgba(129, 215, 66, 1)',
		'rgba(255, 84, 208, 1)',
      ],
      borderWidth: 1,
    },
  ]
}
			});
			
			
			
			
			
					

                }
				
				
                if(typeof response.data.error!=="undefined"){
                        toast.error(response.data.error);
                }
				
				
				

            }else{
				this.setState({
                showReport : false,
                loadingReport : false
				});
				toast.error("Invalid Request!!!!!");
			}
        }).catch((error) => {
			this.setState({
                showReport : false,
                loadingReport : false
			});
			toast.error("Invalid Request!!!!");
		});				
			
		
			
		}else{
			this.setState({
                showReport : false,
                loadingReport : false
			});
			toast.error("Invalid Date!!!");
		}

    }

    render() {
        const { t } = this.props;
		
        return (
            <React.Fragment>
                <ReportsHeader title="General Reports"/>
                <div className="settings-center-wrap">
				
				
                    <div className="reportsFilterDiv col-md-6" style={{ flex:"none"}}>
					
						<div className="form-row">
						
							<div className="form-group col-md-5">
								<label htmlFor="inputStart">Start</label>
								<input type="date" className="form-control" id="inputStart"
									defaultValue={this.state.filterStart}
                                    onChange={this.onChangeFilterStart.bind(this)}
								/>
							</div>
						
							<div className="form-group col-md-5">
								<label htmlFor="inputEnd">End</label>
								<input type="date" className="form-control" id="inputEnd"
								defaultValue={this.state.filterEnd}
                                onChange={this.onChangeFilterEnd.bind(this)}
								/>
							</div>
							
							<div className="form-group col-md-2">
								<button style={{ width:"100%",height: "100%"}} type="button" className="chat-button chat-button-success ml-1"
								onClick={this.filterReport.bind(this)}
								>
									<span>FILTER</span>
								</button>
							</div>

						</div>
						
					</div>
{this.state.showReport === true &&
<div className="reportChartArea" style={{ width:"100%", background:"#fff", padding:"15px", "border-radius":"10px"}}>
<Line options={this.state.optionsFilter} data={this.state.dataFilter} />


<div className="col-md-7" style={{ "float":"left" }}>
<div className="table-responsive" style={{ "margin-top":"50px" }}>
<table className="table table-bordered table-striped tableReports">
<thead>
    <tr>
      <th scope="col">Hour</th>
      <th scope="col">Total Chat</th>
    </tr>
</thead>
<tbody>
{this.state.filterLabels.map(( val, index ) => {
          return (
            <tr key={index}>
			  <td>{val}</td>
              <td>{this.state.filterChat[index]}</td>
            </tr>
          );
        })}
</tbody>
</table>
</div>
</div>
<div className="col-md-5"  style={{ "float":"left", "margin-top": "70px" }}>
<Pie data={this.state.dataFilter2} />
</div>

</div>


}

{this.state.loadingReport === true &&
<div className="reportChartLoadingArea" style={{ width:"100%", background:"#fff", padding:"15px", "border-radius":"10px"}}>
<p>Loading...</p>
</div>
}


                </div>
            </React.Fragment>
        );
    }
}

export default GeneralReport;
